// onboarding-horas.js — la cuenta de horas escribiendo que arma Quién eres con las respuestas
// del médico (#1850). Es SU número, no una promesa nuestra: sale de lo que él contestó en
// «Cuánto te toma documentar por turno» y «Cuántos turnos haces a la semana».
//
// Fórmula, a la vista en la tarjeta: punto medio del rango × turnos × 50 semanas. Los rangos
// abiertos toman un valor fijo: «Menos de 1h» = 0,5 h, «Más de 4h» = 5 h (#1850, supuesto de
// Sebastián del 26-oct). Con «No hago turnos» no hay cuenta por turno: devuelve null y la tarjeta
// muestra solo el lema. Nunca se dice «ahorras X horas»: eso no está medido (probidad, #1850).

export const HORAS_POR_CARGA = { "<1h": 0.5, "1-2h": 1.5, "2-4h": 3, "+4h": 5 };
export const TURNOS_POR_SEMANA = { 1: 1, "2-3": 2.5, "4+": 4 };
export const SEMANAS_AL_ANO = 50;

/** Horas por turno escribiendo, o null si no respondió cuánto le toma. */
export const horasPorTurno = (v) => HORAS_POR_CARGA[v?.carga_documentacion] ?? null;

/** Horas al año escribiendo (entero), o null si falta un dato o no hace turnos. */
export const horasAlAno = (v) => {
  const porTurno = horasPorTurno(v);
  const turnos = TURNOS_POR_SEMANA[v?.turnos_semana];
  if (porTurno == null || turnos == null) return null;
  return Math.round(porTurno * turnos * SEMANAS_AL_ANO);
};

const ETIQUETA_TURNOS = { 1: "1 turno", "2-3": "2 a 3 turnos", "4+": "4 o más turnos" };
const ETIQUETA_CARGA = { "<1h": "menos de 1 h", "1-2h": "1 a 2 h", "2-4h": "2 a 4 h", "+4h": "más de 4 h" };

/** «2 a 3 turnos × 2 a 4 h por turno × 50 semanas» (cómo se calculó, para mostrarlo). */
export const comoSeCalculo = (v) =>
  `${ETIQUETA_TURNOS[v.turnos_semana]} × ${ETIQUETA_CARGA[v.carga_documentacion]} por turno × ${SEMANAS_AL_ANO} semanas`;

/** Las herramientas reales que marcó (sin «Ninguna» ni «Otra»). */
export const lugaresDelTurno = (v) =>
  (v?.herramientas_turno || []).filter((h) => h !== "ninguna" && h !== "otra");

/** Las mismas horas dichas de otra forma, para que la tarjeta no repita el número igual. */
export const equivalencias = (anual) => {
  if (!anual) return [];
  const jornadas = Math.round(anual / 8);
  const dias = Math.floor(anual / 24);
  return [
    `= ${jornadas} jornadas de 8 h`,
    dias >= 1 ? `= ${dias} ${dias === 1 ? "día" : "días"} seguidos, día y noche` : null,
    `= ${Math.round(anual / 12)} turnos de 12 h al año, solo escribiendo`,
  ].filter(Boolean);
};

/** Días que faltan para `fecha` (YYYY-MM-DD) contando desde `hoy` (YYYY-MM-DD), o null. */
export const diasHasta = (fecha, hoy) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(fecha || "") || !/^\d{4}-\d{2}-\d{2}$/.test(hoy || "")) return null;
  const ms = Date.parse(`${fecha}T12:00:00Z`) - Date.parse(`${hoy}T12:00:00Z`);
  return Math.round(ms / 86400000);
};
